import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { IAppManifest } from '@metaos/hub-sdk';
import { getStaticAppDefinitionsMap } from 'owa-app-definitions/lib/appDefinitions';
import { TaskModuleState } from '../../utils/createTaskModule';
import { default as TaskModule, ITaskModule } from './../taskModule/TaskModule';

export default observer(function AboutDialog(props: TaskModuleState) {
    const { actions, store, usePromiseState } = props;
    const promiseHandlers = usePromiseState();
    const appStoreAppDefinition = React.useMemo(() => {
        const appDefinition = getStaticAppDefinitionsMap()[
            'f3a6e67f-850d-4dd9-960a-04c6638ded36' /* App Store id */
        ];
        return {
            ...appDefinition,
            appId: appDefinition.id,
            showTabLoadingIndicator: appDefinition.showLoadingIndicator,
        };
    }, []);

    const taskModuleProps: ITaskModule = {
        appDefinition: appStoreAppDefinition as IAppManifest,
        actions,
        promiseHandlers,
        store,
        shouldShowHeader: false,
    };

    return <TaskModule {...taskModuleProps} />;
});
